import React, { useContext } from "react";
import {
  formatNumber,
  Toggle,
  Tooltip,
  useBreakpoints,
} from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { TextFit } from "cerulean";

import SectionCard from "../../SectionCard";
import AccountContext from "../../contexts/AccountContext";
import { filterDepositAccounts, useAccountsTotal } from "./hooks";
import { useCurrentUserBalanceChartStorage } from "../Charts/storage";

const AccountTotalsCard = () => {
  const { l10n } = useLocalization();
  const { depositAccounts } = useContext(AccountContext);
  const hiddenDepositAccountsLength = depositAccounts.filter(
    (acc) =>
      acc.hidden === true && acc.product_type !== "certificate_of_deposit"
  ).length;
  const nonHiddenDepositAccounts = filterDepositAccounts(depositAccounts);
  const [chartPreferences, setChartPreferences] =
    useCurrentUserBalanceChartStorage();
  const showHidden = chartPreferences.includeHiddenAccounts;
  const { s } = useBreakpoints();

  const accountsTotal = useAccountsTotal(
    depositAccounts,
    nonHiddenDepositAccounts,
    showHidden
  );

  return (
    <SectionCard>
      <div className="alignChild--left--center">
        <h4
          className="fontColor--primary fontSize--m fontWeight--normal fontFamily--body margin--right--xxs"
          data-testid="total-available-cash-header"
        >
          {l10n.getString(
            "heading-total-available-cash",
            null,
            "Total available cash"
          )}
        </h4>
        <Tooltip
          text={l10n.getString(
            "tooltip-total-available-cash",
            null,
            "Total cash is the cash available for spending or withdrawals. It does not include balances from CDs or liabilities."
          )}
          maxWidth={s ? "476px" : "350px"}
        >
          <div className="alignChild--center--center">
            <span className="narmi-icon-info fontSize--xxs" />
          </div>
        </Tooltip>
      </div>
      <div
        className="available-balance-header fontWeight--bold"
        data-testid="total-available-cash-amount"
      >
        <TextFit
          ariaLive="polite"
          text={formatNumber(accountsTotal, "currency")}
        />
      </div>
      {hiddenDepositAccountsLength > 0 && (
        <div className="hidden-total" data-testid="hidden-total-toggle">
          <hr />
          <Toggle
            isActive={showHidden}
            label={l10n.getString(
              "tooltip-include-hidden-accounts",
              null,
              "Include hidden accounts"
            )}
            onChange={() => {
              setChartPreferences((previous) => ({
                ...previous,
                includeHiddenAccounts: !previous.includeHiddenAccounts,
              }));
            }}
          />
        </div>
      )}
    </SectionCard>
  );
};
export default AccountTotalsCard;
